import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as moment from "moment";
import { Observable } from "rxjs";
import { ApiService } from "./api/api.service";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  // if add all date keys here
  private dateTypes = [
    "start_date",
    "end_date",
    "start_date_to",
    "start_date_from",
    "end_date_to",
    "end_date_from",
  ];
  constructor(private http: ApiService) {}

  getDataWithoutNullValues(value: any): any {
    const formatData = {};
    Object.keys(value).forEach((item) => {
      if (value[item] !== null && value[item] !== "") {
        if (this.dateTypes.includes(item)) {
          formatData[item] = moment(value[item]).format("Y-MM-DD HH:mm:ss");
        } else {
          formatData[item] = value[item];
        }
      }
    });
    return formatData;
  }

  fetchAuctionsList(requestData: any): Observable<any> {
    return this.http.get("admin/auctions", {
      params: this.getDataWithoutNullValues(requestData),
    });
  }

  fetchAuction(auctionId: number | string): Observable<any> {
    return this.http.get("admin/auctions/" + auctionId);
  }

  updateAuction(requestData: any, auctionId: number | string): Observable<any> {
    // https://jsonplaceholder.typicode.com/users
    return this.http.patch(
      "admin/auctions/" + auctionId,
      this.getDataWithoutNullValues(requestData),
    );
  }

  fetchBalanceWithdrawList(requestData: any): Observable<any> {
    return this.http.get("admin/refund-requests", {
      params: this.getDataWithoutNullValues(requestData),
    });
  }

  balanceWithdrawStatusChange(
    requestData: any,
    balanceWithdrawItemId: number | string,
  ): Observable<any> {
    return this.http.post(
      `admin/refund-requests/${balanceWithdrawItemId}`,
      requestData,
    );
  }

  fetchUserData(userId: number | string): Observable<any> {
    return this.http.get("admin/users/" + userId);
  }

  fetchUnprocessedTransactionsList(requestData: any): Observable<any> {
    return this.http.get("admin/transactions/unprocessed", {
      params: this.getDataWithoutNullValues(requestData),
    });
  }

  fetchTransactionsList(requestData: any): Observable<any> {
    return this.http.get("admin/transactions", {
      params: this.getDataWithoutNullValues(requestData),
    });
  }

  refundPayment({ item_id, amount }): Observable<any> {
    return this.http.post("admin/transactions/refund/" + item_id, {
      amount: amount,
    });
  }

  refundedPayment(item_id: number): Observable<any> {
    return this.http.get("admin/transactions/refunded-payments/" + item_id);
  }
}
